import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner
} from "reactstrap";

import axios from "axios";
import "../Assets/css/style.css";
import AdminSidebar from "../Partials/adminsidebar";

const UpdateQuestion = () => {

  const [loading, setLoading] = useState(false);

  const [domains] = useState([
    { id: "1", name: "Content Creation" },
    { id: "2", name: "Sales" },
    { id: "3", name: "Accountant" }
  ]);

  const [questions, setQuestions] = useState([]);

  const [formData, setFormData] = useState({
    question_id: "",
    domain_id: "",
    question: "",
    max_marks: "",
    correct_answer: "",
    keywords: ""
  });

  // ⭐ Load questions by domain
  const fetchQuestionsByDomain = async (domainId) => {

    setFormData({
      ...formData,
      domain_id: domainId,
      question_id: ""
    });

    try {

      const token = localStorage.getItem("admin_token");

      const res = await axios.get(
        // "http://localhost/qads_interview/question/list.php",
        "https://interview.qads.co.in/qads_interview/question/list.php",
        {
          params: { domain_id: domainId },
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (res.data.status) {
        setQuestions(res.data.data.questions);
      }

    } catch (err) {
      console.log(err);
    }
  };

  // ⭐ When question selected → Auto fill fields
  const handleQuestionSelect = (questionId) => {

    const selected = questions.find(q => q.id === questionId);

    setFormData({
      ...formData,
      question_id: questionId,
      question: selected?.question || "",
      max_marks: selected?.max_marks || "",
      correct_answer: selected?.correct_answer || "",
      keywords: selected?.keywords || ""
    });

  };

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    setLoading(true);

    try {

      const token = localStorage.getItem("admin_token");

      const response = await axios.post(
        // "http://localhost/qads_interview/question/update.php",
        "https://interview.qads.co.in/qads_interview/question/update.php",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );

      alert(response.data.message);

      // ⭐ Refresh data after update
      setFormData({
        question_id: "",
        domain_id: "",
        question: "",
        max_marks: "",
        correct_answer: "",
        keywords: ""
      });


    } catch (error) {

      alert(error.response?.data?.message || "Server error");

    }

    setLoading(false);
  };

  return (
    <div className="update-page">
      <div style={{ display: "flex" }}>
        <AdminSidebar />

        <div style={{ marginLeft: "250px", width: "100%", padding: "20px" }}>
          <Container fluid>
            <Row className="justify-content-center">
              <Col md="8">

                <Card className="update-card">
                  <CardBody>

                    <CardTitle className="update-title">
                      Update Question
                    </CardTitle>

                    <Form onSubmit={handleSubmit}>

                      {/* Domain Dropdown */}
                      <FormGroup>
                        <Label>Select Domain</Label>

                        <Input
                          type="select"
                          value={formData.domain_id}
                          onChange={(e) =>
                            fetchQuestionsByDomain(e.target.value)
                          }
                        >
                          <option value="">Select Domain</option>

                          {domains.map(d => (
                            <option key={d.id} value={d.id}>
                              {d.name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      {/* Question Dropdown */}
                      <FormGroup>
                        <Label>Select Question</Label>

                        <Input
                          type="select"
                          value={formData.question_id}
                          onChange={(e) =>
                            handleQuestionSelect(e.target.value)
                          }
                        >
                          <option value="">Select Question</option>

                          {questions.map(q => (
                            <option key={q.id} value={q.id}>
                              {q.question.substring(0, 80)}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>

                      {/* Question Text */}
                      <FormGroup>
                        <Label>Question</Label>
                        <Input
                          type="textarea"
                          name="question"
                          value={formData.question}
                          onChange={handleChange}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Max Marks</Label>
                        <Input
                          type="number"
                          name="max_marks"
                          value={formData.max_marks}
                          onChange={handleChange}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Correct Answer</Label>
                        <Input
                          type="text"
                          name="correct_answer"
                          value={formData.correct_answer}
                          onChange={handleChange}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label>Keywords</Label>
                        <Input
                          type="text"
                          name="keywords"
                          value={formData.keywords}
                          onChange={handleChange}
                        />
                      </FormGroup>

                      <Button
                        className="update-btn"
                        block
                        disabled={loading}
                      >
                        {loading ? <Spinner size="sm" /> : "Update Question"}
                      </Button>

                    </Form>

                  </CardBody>
                </Card>

              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default UpdateQuestion;